module.exports = __webpack_public_path__ + "img/maintenance-drop-arrow.80a94751.svg";